import { getAuthTokenProp } from './auth'

export function getRole () {
  return getAuthTokenProp('role')
}

export function isAdmin () {
  const role = getRole()
  return role === 'admin'
}

export function isCustomerSupport () {
  const role = getRole()
  return role === 'customer_support'
}

export function isOperations () {
  return isAdmin() || isCustomerSupport()
}



// WEBPACK FOOTER //
// ./src/shared/utils/auth/user.js